import React, { useContext, useState, useEffect } from "react";
import { Row, Col, Progress } from "antd";
import UserBasicInfo from "../Users/UserDetails/UserBasicInfo";
import VideoIdentification from "../Users/UserDetails/VideoIdentification";
import ComfortingMessage from "./UserDetails/ComfortingMessage";
import ContactInfo from "./UserDetails/ContactInfo";
import PrimaryContacts from "./UserDetails/PrimaryContacts";
import PersonalInfo from "./UserDetails/PersonalInfo";
import MedicalInfo from "./UserDetails/MedicalInfo";
import VitalInfo from "./UserDetails/VitalInfo";
import RecentActivity from "./UserDetails/RecentActivity";
import StatInfo from "./UserDetails/StatInfo";
import AppContext from "../../../../config/AppContext";

export default function UserDetails({ isMobile }) {
  const { profileDetails } = useContext(AppContext);
  const [emergencyContacts, setEmergencyContacts] = useState(null);

  useEffect(() => {
    setEmergencyContacts(null);
  }, [profileDetails]);

  return (
    <Row gutter={[28, 28]}>
      <Col
        xxl={{ span: 8 }}
        xl={{ span: 8 }}
        lg={{ span: 8 }}
        md={{ span: 24 }}
        sm={{ span: 24 }}
        xs={{ span: 24 }}
      >
        <div
          className="card-container"
          style={{
            background: "#FFF",
            borderRadius: "10px",
            padding: "28px",
          }}
        >
          <Row gutter={[0, 28]}>
            <Col span={24} style={{ marginBottom: "-16px" }}>
              <UserBasicInfo
                profileInfo={profileDetails?.addIndivualData}
                profilePic={profileDetails?.securedFileUrl}
                profileCode={profileDetails?.profileCode}
              />
              <div style={{ marginTop: "5px" }}>
                <Progress
                  strokeLinecap="round"
                  strokeColor={"#6a347d"}
                  percent={parseInt(profileDetails?.completedProfilePercentage)}
                />
              </div>
            </Col>

            <Col span={24}>
              <Row gutter={[16, 16]}>
                {profileDetails?.individualId?.securedFileUrl && (
                  <Col
                    xxl={{ span: 12 }}
                    xl={{ span: 12 }}
                    lg={{ span: 12 }}
                    md={{ span: 24 }}
                    sm={{ span: 24 }}
                    xs={{ span: 24 }}
                  >
                    <VideoIdentification
                      individualId={
                        profileDetails?.individualId?.securedFileUrl
                      }
                    />
                  </Col>
                )}

                {profileDetails?.comfortingMessage?.securedFileUrl && (
                  <Col
                    xxl={{ span: 12 }}
                    xl={{ span: 12 }}
                    lg={{ span: 12 }}
                    md={{ span: 24 }}
                    sm={{ span: 24 }}
                    xs={{ span: 24 }}
                    style={{ paddingLeft: "10px" }}
                  >
                    <ComfortingMessage
                      comfortingMessage={
                        profileDetails?.comfortingMessage?.securedFileUrl
                      }
                    />
                  </Col>
                )}
              </Row>
            </Col>

            <Col span={24}>
              <Row justify={"space-between"}>
                <Col
                  xxl={{ span: 12 }}
                  xl={{ span: 12 }}
                  lg={{ span: 12 }}
                  md={{ span: 24 }}
                  sm={{ span: 24 }}
                  xs={{ span: 24 }}
                >
                  <div style={{ marginTop: "-18px" }}>
                    {emergencyContacts > 0 ? (
                      <div>
                        <ContactInfo
                          contactInfo={profileDetails?.contactInfo}
                          showAllInfo={false}
                          isDispatcherPhone={
                            parseInt(
                              profileDetails?.orgSettings?.masterAccountPhone?.replace(
                                /[^0-9]/g,
                                ""
                              )
                            ) ===
                            parseInt(
                              profileDetails?.contactInfo?.phone?.replace(
                                /[^0-9]/g,
                                ""
                              )
                            )
                              ? true
                              : false
                          }
                        />

                        <div
                          style={{
                            marginTop: "10px",
                          }}
                        >
                          <PersonalInfo
                            identification={profileDetails?.identification}
                            isFull={false}
                          />
                        </div>
                      </div>
                    ) : (
                      <ContactInfo
                        contactInfo={profileDetails?.contactInfo}
                        showAllInfo={true}
                        isDispatcherPhone={
                          parseInt(
                            profileDetails?.orgSettings?.masterAccountPhone?.replace(
                              /[^0-9]/g,
                              ""
                            )
                          ) ===
                          parseInt(
                            profileDetails?.contactInfo?.phone?.replace(
                              /[^0-9]/g,
                              ""
                            )
                          )
                            ? true
                            : false
                        }
                      />
                    )}
                  </div>
                </Col>

                <Col
                  xxl={{ span: 12 }}
                  xl={{ span: 12 }}
                  lg={{ span: 12 }}
                  md={{ span: 24 }}
                  sm={{ span: 24 }}
                  xs={{ span: 24 }}
                >
                  <div style={{ marginTop: isMobile ? "18px" : "-18px" }}>
                    {(emergencyContacts > 0 && emergencyContacts !== 0) ||
                    emergencyContacts === null ? (
                      <PrimaryContacts
                        contactInfo={profileDetails?.contactInfo}
                        profileId={profileDetails?.id}
                        emergencyCount={(value) => setEmergencyContacts(value)}
                        showTile={true}
                      />
                    ) : (
                      <PersonalInfo
                        identification={profileDetails?.identification}
                        isFull={true}
                      />
                    )}
                  </div>
                </Col>
              </Row>
            </Col>

            <Col
              xxl={{ span: 24 }}
              xl={{ span: 24 }}
              lg={{ span: 24 }}
              md={{ span: 24 }}
              sm={{ span: 24 }}
              xs={{ span: 24 }}
              id="recentActivityParent"
            >
              <RecentActivity
                isMobile={isMobile}
                criticalInfoScriptId={profileDetails?.criticalinfoScript?.id}
                profileId={profileDetails?.id}
                orgId={profileDetails?.orgId}
                profileUserNames={{
                  firstName: profileDetails?.addIndivualData?.firstName,
                  nickName: profileDetails?.addIndivualData?.nickName,
                  dbNickName: profileDetails?.addIndivualData?.dbNickName,
                }}
              />
            </Col>
          </Row>
        </div>
      </Col>

      <Col
        xxl={{ span: 16 }}
        xl={{ span: 16 }}
        lg={{ span: 16 }}
        md={{ span: 24 }}
        sm={{ span: 24 }}
        xs={{ span: 24 }}
      >
        <Row gutter={[0, 28]}>
          <Col span={24}>
            <Row gutter={[28, 28]}>
              <Col
                xxl={{ span: 12 }}
                xl={{ span: 12 }}
                lg={{ span: 12 }}
                md={{ span: 24 }}
                sm={{ span: 24 }}
                xs={{ span: 24 }}
              >
                <div className="card-container">
                  <VitalInfo
                    firstResponderNotes={profileDetails?.firstResponderNotes}
                    warningIcons={profileDetails?.warningIcons}
                  />
                </div>
              </Col>

              <Col
                xxl={{ span: 12 }}
                xl={{ span: 12 }}
                lg={{ span: 12 }}
                md={{ span: 24 }}
                sm={{ span: 24 }}
                xs={{ span: 24 }}
              >
                <div className="card-container">
                  <MedicalInfo profileId={profileDetails?.id} />
                </div>
              </Col>
            </Row>
          </Col>

          <Col span={24} id="statInfoParent">
            <div className="card-container">
              <StatInfo
                isMobile={isMobile}
                criticalInfoScriptId={profileDetails?.criticalinfoScript?.id}
                criticalInfoScriptIcon={
                  profileDetails?.criticalinfoScript?.securedFileUrl
                }
                profileId={profileDetails?.id}
                orgId={profileDetails?.orgId}
                profileUserNames={{
                  firstName: profileDetails?.addIndivualData?.firstName,
                  nickName: profileDetails?.addIndivualData?.nickName,
                  dbNickName: profileDetails?.addIndivualData?.dbNickName,
                }}
              />
            </div>
          </Col>
        </Row>
      </Col>
    </Row>
  );
}
